import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import StyledModal from 'components/styled_modal';

const LoginAlertModal = ({ loginAlert, setLoginAlert, onContinue }) => (
  <>
    {loginAlert && (
      <StyledModal
        show={Boolean(loginAlert)}
        onHide={() => setLoginAlert(null)}
      >
        <StyledModal.Body>{parse(loginAlert)}</StyledModal.Body>
        <StyledModal.Footer>
          <div className="row w-100 justify-content-between">
            <div className="col-3 p-0">
              <a
                className="btn btn-outline-grey w-100"
                href={`${ecom.craftConfig.api_prefix}/account/logout`}
              >
                Cancel
              </a>
            </div>
            <div className="col-8 p-0">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={onContinue}
              >
                Agree and continue
              </button>
            </div>
          </div>
        </StyledModal.Footer>
      </StyledModal>
    )}
  </>
);

LoginAlertModal.propTypes = {
  loginAlert: PropTypes.string,
  setLoginAlert: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default LoginAlertModal;
